import axios from '@fs/zion-axios'
import { clearStartingPidCache } from '@fs/zion-tree-groups'

/**
 * Decline an invite made to the current user.
 * @param {string} groupId - The group's ID.
 * @param {string} inviteId - The invite ID generated for the email invitation.
 * @throws 400 - Invalid group id
 * @throws 400 - User is already a member of the group
 * @throws 400 - Unable to join group due to group or user limitations
 * @throws 400 - Invalid inviteId
 * @throws 403 - User is banished from the group
 * @throws 404 - Group not found
 * @throws 404 - Group invite not found
 * @throws 410 - Group is tombstoned
 * @returns {Promise} axios.post promise
 */
export default function declineInvitation(groupId, inviteId) {
  clearStartingPidCache()
  return axios.post(`/service/tree/tree-data/groups/${groupId}/invites/${inviteId}?reject=true`)
}
